var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("filter-base", {
    attrs: {
      options: _vm.specialities,
      label: "Speciality",
      closeOnSelect: _vm.closeOnSelect
    },
    model: {
      value: _vm.selectedSpecialities,
      callback: function($$v) {
        _vm.selectedSpecialities = $$v
      },
      expression: "selectedSpecialities"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }